import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import Footer from '../components/Footer';

const CompanyRegistrationSuccess: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="blue-sky-glass border-b border-white/20 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
          <div className="flex justify-between items-center py-3 sm:py-4 lg:py-6">
            <Link to="/" className="flex items-center" aria-label="Break Room Cup">
              <Logo size="sm" />
            </Link>
          </div>
        </div>
      </header>

      {/* Success Content */}
      <main className="max-w-2xl mx-auto px-3 sm:px-4 lg:px-8 py-12 sm:py-16 lg:py-24">
        <div className="blue-sky-card rounded-xl p-8 sm:p-12 text-center border border-white/20">
          <div className="mb-6">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-4">
              <span className="text-4xl sm:text-5xl">✓</span>
            </div>
          </div>
          
          <h1 className="font-display text-display-1 font-bold mb-4 text-foreground">
            Registration Submitted Successfully!
          </h1>
          
          <p className="text-body-lg text-muted-foreground mb-8">
            Thank you for your interest in organizing a corporate chess tournament with Break Room Cup.
          </p>
          
          <div className="bg-white/10 rounded-lg p-6 mb-8 text-left">
            <h2 className="text-xl font-semibold mb-4 text-white">What happens next?</h2>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start">
                <span className="text-sky-400 mr-2">✓</span>
                <span>We've received your registration and will review it shortly.</span>
              </li>
              <li className="flex items-start">
                <span className="text-sky-400 mr-2">✓</span>
                <span>Our team will contact you within 48 hours via the email you provided.</span>
              </li>
              <li className="flex items-start">
                <span className="text-sky-400 mr-2">✓</span>
                <span>We'll discuss your tournament requirements and help you plan the perfect event.</span>
              </li>
              <li className="flex items-start">
                <span className="text-sky-400 mr-2">✓</span>
                <span>We'll provide you with a customized proposal and pricing.</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex justify-center w-full sm:w-auto bg-primary hover:opacity-90 text-primary-foreground px-6 py-3 rounded-xl text-nav font-semibold transition-all"
            >
              Return to Home
            </Link>
            <p className="text-body-lg text-muted-foreground">
              If you have any urgent questions, please contact us at{' '}
              <a href="mailto:breakroomcup@gmail.com" className="text-sky-400 hover:underline">
                breakroomcup@gmail.com
              </a>
            </p>
          </div>
        </div>
      </main>

      <Footer className="mt-12" />
    </div>
  );
};

export default CompanyRegistrationSuccess;

